var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBath = function SvgBath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.733 6.4V4.8a.533.533 0 1 1 1.067 0h1.067a1.6 1.6 0 0 0-3.2 0v1.6H1.6v1.067c.59 0 1.067.477 1.067 1.066V9.6c0 1.178.954 2.133 2.132 2.133V12.8h1.067v-1.067h4.268V12.8h1.067v-1.067A2.134 2.134 0 0 0 13.333 9.6V8.533c0-.589.478-1.066 1.067-1.066V6.4H3.733Zm8.534 2.133V9.6a1.067 1.067 0 0 1-1.067 1.067H4.8A1.067 1.067 0 0 1 3.733 9.6V8.533c0-.39-.113-.752-.296-1.066h9.125a2.111 2.111 0 0 0-.295 1.066Z",
    fill: "#000"
  }))));
};
export default SvgBath;